import React from 'react';
import ProfileChangeInfoArea from '../ProfileChangeInfoArea/ProfileChangeInfoArea';
import ProfileChangePasswordArea from '../ProfileChangePasswordArea/ProfileChangePasswordArea';
import StyledProfileMainContent from './ProfileMainContent.styles';
import PageTitle from '../../../../components/PageTitle';
import SubscriptionArea from '../SubscriptionArea';
import { useAppSelector } from '../../../../store/hooks';

const ProfileMainContent = () => {
  const isAdminUser = useAppSelector(
    (state) => state.userSlice.user.isSuperUser,
  );
  return (
    <StyledProfileMainContent>
      <PageTitle title="Edit Profile" />
      <ProfileChangeInfoArea />
      {!isAdminUser && (
        <SubscriptionArea />
      )}
      <ProfileChangePasswordArea />
    </StyledProfileMainContent>
  );
};

export default ProfileMainContent;
